import { Link } from 'react-router-dom';
import { navItems, siteInfo } from '@/mocks/brand';

const LOGO_URL = 'https://storage.readdy-site.link/project_files/999b20db-023a-415b-8938-ab1563276c79/adab1eea-aa1c-4be9-9113-c915a6c79d56_compressed_-01.webp';

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-background-100 relative overflow-hidden">
      <div className="absolute inset-0 flex items-center justify-center select-none pointer-events-none opacity-[0.03]">
        <span className="font-heading text-[20vw] font-bold tracking-tighter whitespace-nowrap">
          沐燁
        </span>
      </div>

      <div className="relative z-10 mx-auto max-w-[1440px] px-6 md:px-10 pt-16 pb-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-8 mb-14">
          {/* Column 1: Brand Identity */}
          <div>
            <Link to="/" className="inline-flex items-center gap-2 mb-4 cursor-pointer">
              <img
                src={LOGO_URL}
                alt={siteInfo.brandName}
                className="h-8 w-8 object-contain rounded"
              />
              <span className="font-heading text-xl font-bold tracking-wide text-background-50">
                {siteInfo.brandNameShort}
              </span>
            </Link>
            <p className="text-xs text-background-300/50 tracking-[0.2em] uppercase mb-3">
              {siteInfo.englishName}
            </p>
            <p className="text-sm text-background-200/80 leading-relaxed mb-3">
              {siteInfo.publishingDirectionText}
            </p>
            <p className="text-xs text-background-300/60 mb-1">
              {siteInfo.siteUrl}
            </p>
            <p className="text-xs text-background-300/50 leading-relaxed">
              {siteInfo.brandRelationText}
            </p>
          </div>

          {/* Column 2: Site Navigation */}
          <div>
            <h4 className="text-xs font-medium uppercase tracking-wider text-background-200/60 mb-4">
              網站導覽
            </h4>
            <div className="flex flex-col gap-2.5">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className="text-sm text-background-200 hover:text-background-50 transition-colors duration-200 cursor-pointer"
                >
                  {item.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Column 3: Related Sites */}
          <div>
            <h4 className="text-xs font-medium uppercase tracking-wider text-background-200/60 mb-4">
              相關站點
            </h4>
            <div className="flex flex-col gap-2.5">
              <a
                href={siteInfo.parentUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-background-200 hover:text-background-50 transition-colors duration-200 cursor-pointer flex items-center gap-1.5"
              >
                崧博出版主站
                <span className="w-3 h-3 flex items-center justify-center">
                  <i className="ri-external-link-line text-[10px]"></i>
                </span>
              </a>
              <a
                href={siteInfo.catalogUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-background-200 hover:text-background-50 transition-colors duration-200 cursor-pointer flex items-center gap-1.5"
              >
                崧博書籍資料庫
                <span className="w-3 h-3 flex items-center justify-center">
                  <i className="ri-external-link-line text-[10px]"></i>
                </span>
              </a>
              <p className="text-xs text-background-300/40 leading-relaxed mt-1">
                {siteInfo.catalogDisclaimer}
              </p>
            </div>
          </div>

          {/* Column 4: Purchase Channels */}
          <div>
            <h4 className="text-xs font-medium uppercase tracking-wider text-background-200/60 mb-4">
              購書通路
            </h4>
            <div className="flex flex-col gap-2.5">
              <a
                href="https://www.books.com.tw/web/sys_puballb/books/?pubid=sungpo7"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-background-200 hover:text-background-50 transition-colors duration-200 cursor-pointer flex items-center gap-1.5"
              >
                博客來品牌書目
                <span className="w-3 h-3 flex items-center justify-center">
                  <i className="ri-external-link-line text-[10px]"></i>
                </span>
              </a>
              <a
                href="https://www.eslite.com/search?keyword=沐燁文化"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-background-200 hover:text-background-50 transition-colors duration-200 cursor-pointer flex items-center gap-1.5"
              >
                誠品線上
                <span className="w-3 h-3 flex items-center justify-center">
                  <i className="ri-external-link-line text-[10px]"></i>
                </span>
              </a>
              <a
                href="https://www.kingstone.com.tw/bookpublish/publist/62459/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-background-200 hover:text-background-50 transition-colors duration-200 cursor-pointer flex items-center gap-1.5"
              >
                金石堂網路書店
                <span className="w-3 h-3 flex items-center justify-center">
                  <i className="ri-external-link-line text-[10px]"></i>
                </span>
              </a>
              <Link
                to="/stores"
                className="text-sm text-accent-400 hover:text-accent-300 transition-colors duration-200 cursor-pointer"
              >
                查看全部合作通路 →
              </Link>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-background-200/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-300/60">
            &copy; {new Date().getFullYear()} 沐燁文化 MOYA.
          </p>
          <div className="flex items-center gap-4">
            <a
              href={siteInfo.parentUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1.5 text-xs text-background-300/60 hover:text-background-100 transition-colors duration-200 cursor-pointer"
            >
              前往崧博出版
              <span className="w-3 h-3 flex items-center justify-center">
                <i className="ri-external-link-line text-[10px]"></i>
              </span>
            </a>
            <a
              href={siteInfo.catalogUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1.5 text-xs text-background-300/60 hover:text-background-100 transition-colors duration-200 cursor-pointer"
            >
              前往書籍資料庫
              <span className="w-3 h-3 flex items-center justify-center">
                <i className="ri-external-link-line text-[10px]"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}